import React from 'react'
import Select from 'lib/components/select'
import RA from 'ra-config'
import withSend from 'microcosm/addons/with-send'

const { regionOptionList } = RA.app.page

const RegionSelect = withSend(({ send, region }) => {
  const selected = region || regionOptionList.find(i => i.default)
  const onChange = e => {
    const { value, options, selectedIndex } = e.target
    const text = options[selectedIndex].innerText
    send('filterRegion', { value, text })
  }

  return (
    <span className="region-filter">
      <Select
        label="Market:"
        labelFor="region-filter"
        onChange={onChange}
        options={regionOptionList}
        selected={selected.value}
        selectedText={selected.text}
      />
    </span>
  )
})

export default RegionSelect



// WEBPACK FOOTER //
// ./src/components/region-select.js